// Ensure TS knows we have a specical global variable defined.
declare global {
  interface Window {
    __Loaded: object
  }
}

/**
 * Returns the value of the configuration item with the given key if it is
 * defined. If a config item is not defined, a provided default will be
 * returned, else the return value will be undefined.
 *
 * Note that the configuration lives on the `window.__Loaded` globale variable
 * that is defined in the index.html file and can be updated during the release
 * deployment process.
 * @param key
 * @returns
 */
function get(key: string, defaultValue = undefined): string {
  return (window.__Loaded || {})[key] || defaultValue
}

export default {
  get,
}
